import app from 'flarum/forum/app';
app.initializers.add('val-ui-tag-shortcuts', () => {
  /*
   * VAL — un forum ou sous-forum contenant exactement une discussion
   * ouvre directement cette discussion.
   *
   * L'ID de cette discussion est calculé côté PHP et exposé par
   * l'attribut API valUniqueDiscussionId.
   */

  function tagFromUrl(href) {
    let url;
    try {
      url = new URL(href, location.href);
    } catch (_) {
      return null;
    }
    if (url.origin !== location.origin) return null;
    const match = url.pathname.match(/\/t\/([^/]+)\/?$/);
    if (!match) return null;
    let slug;
    try {
      slug = decodeURIComponent(match[1]);
    } catch (_) {
      slug = match[1];
    }
    return app.store.all('tags').find(tag => {
      if (!tag || typeof tag.slug !== 'function') return false;
      const candidate = tag.slug();
      return candidate && candidate.localeCompare(slug, undefined, {
        sensitivity: 'base'
      }) === 0;
    }) || null;
  }
  function directTarget(tag) {
    if (!tag || typeof tag.attribute !== 'function') return null;
    let id = null;
    try {
      id = Number(tag.attribute('valUniqueDiscussionId'));
    } catch (_) {
      return null;
    }
    if (!Number.isInteger(id) || id <= 0) return null;
    return '/d/' + id;
  }
  function rewriteLinks(root) {
    if (root === void 0) {
      root = document;
    }
    root.querySelectorAll('a[href]').forEach(link => {
      const tag = tagFromUrl(link.href);
      if (!tag) return;
      const target = directTarget(tag);
      if (!target) return;
      link.href = target;
      link.dataset.valTagShortcut = '1';
    });
  }
  const start = () => {
    rewriteLinks();

    // TEST PERF : MutationObserver global désactivé
  };
  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, {
      once: true
    });
  }

  /*
   * Mithril peut conserver son gestionnaire de route même après
   * modification du href : interception avant le routeur Flarum.
   */
  document.addEventListener('click', e => {
    if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey) {
      return;
    }
    const link = e.target.closest('a[href]');
    if (!link) return;
    let target = null;
    if (link.dataset.valTagShortcut === '1') {
      target = link.href;
    } else {
      const tag = tagFromUrl(link.href);
      target = directTarget(tag);
    }
    if (!target) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const url = new URL(target, location.origin);
    m.route.set(url.pathname + url.search + url.hash);
  }, true);
});